import * as React from "react";
import * as __intl__ from "@frameio/i18n";
export type Text = {
    untitled: string;
};
export type Deps = {};
export default {
    DEFINE(_messages: Text, {}: Deps = {}): void {
        return Object.defineProperties(this, {
            /** Fallback text for folders without a name */
            untitled: {
                get() {
                    return __intl__.withIntl(this[__intl__.BOUND_INTL] ?? __intl__.getIntl(), () => __intl__.intl().formatMessage({ id: "AssetPathnameResult.untitled?c=2x432uzeydtjf", defaultMessage: "untitled folder" }));
                },
                enumerable: true,
                configurable: true
            }
        });
    }
} as Text & {
    DEFINE(messages: Text, deps?: Deps): void;
};
